import gql from 'graphql-tag'

export const subscriptionOfferQuery = gql`
  query DooerComGetSubscriptionOffer($organizationId: ID!, $id: ID!) {
    organization(id: $organizationId) {
      id
      subscriptionOffer(id: $id) {
        id
        feeExVat
        title
        description {
          plain
          html
        }
        affectingVariables {
          name
          value
        }
        validThru
        isAccepted
      }
    }
  }
`

export const acceptSubscriptionOfferMutation = gql`
  mutation DooerComAcceptSubscriptionOffer($organizationId: ID!, $id: ID!) {
    organization(id: $organizationId) {
      subscriptionOffer(id: $id) {
        acceptWithBankId {
          id
          autoStartToken
        }
      }
    }
  }
`
